export default{
	global:{
		chinese:"zh",
		home:{
			companyProfile:"Company Profile",
			companyProfile1:"Inkstar is a professional manufacturer of themal transfer ribbon which established in 1992,",
			companyProfile2:"The main products of the factory include: wax-based carbon belt, mixed carbon belt, resin carbon belt, color wax-based carbon belt, color mixed carbon belt, color resin carbon belt, edge pressure TTO carbon belt, water washing carbon belt, high-temperature resistant resin carbon belt, outdoor power grid carbon belt, card carbon belt, color card carbon belt and other types of carbon belt.",
			kh1:"Quality First",
			kh2:"Achieve Customers",
			kh3:"Technological Innovation",
			kh4:"Unite And Fight",
			companyHonors:"Enterprise Qualification",
			companyProducts:"Company Products",
			companyGrid:"Quality Control Center",
			grid1:"Yingshida's marketing service network is sound and complete. It has sales offices in Tianjin, Beijing, Hebei Province, Henan Province, Zhejiang Province, Guangdong Province, Shandong Province, Yunnan Province, Fujian Province, Hunan Province, Hubei Province, the United States, Dubai, Mexico, Thailand, Mauritius, Pakistan, Iran, Vietnam, Colombia and other large and medium-sized cities. Product sales cover the country and are exported to more than 70 countries and regions. Foreign trade exports account for nearly 65% of the total income."
		},
		product:{
			productInformation:"Product Information",
			productWidth:"Product Width",
			productLength:"Product Length",
			productCarbonSurface:"Product Carbon Surface",
			productAxis:"Product Axis",
			productColor:"Product Color",
			productCustomization:"Product Customization",
			productJZ:"Recommended Media",
			detail:"Detailed Information"
		},
		suppor:{
			clickPreview:"Click Preview",
			commonProblem:"Common Problem",
			dataDownload:"Data Download",
			anomalyAnalysis:"Anomaly Analysis",
			troubleshootingAndSolutions:"Troubleshooting And Solutions",
			colorPage:"Product Color Page",
		}
	}
}